// Style copié entre widgets — dans Orion tout le style presentationnel vit dans config.display.
const STYLE_KEYS = ['display'] as const
type Config = Record<string, unknown>

let clipboard: { type: string; style: Config } | null = null
const listeners = new Set<() => void>()

/** Copie le style presentationnel (config.display) d'un widget vers le clipboard. */
export function copyStyle(type: string, config: Config) {
  const style: Config = {}
  for (const k of STYLE_KEYS) if (config[k] !== undefined) style[k] = config[k]
  clipboard = { type, style }
  listeners.forEach((f) => f())
}

/**
 * Fusionne le style du clipboard dans un config cible (display deep-merge,
 * clipboard prioritaire). Renvoie null si rien n'a encore été copié.
 */
export function pasteStyle(config: Config): Config | null {
  if (!clipboard) return null
  const merged: Config = { ...config, ...clipboard.style }
  if (clipboard.style.display !== undefined || config.display !== undefined) {
    merged.display = { ...((config.display as Config) ?? {}), ...((clipboard.style.display as Config) ?? {}) }
  }
  return merged
}

export function getClipboard() {
  return clipboard
}

export function subscribeClipboard(fn: () => void) {
  listeners.add(fn)
  return () => {
    listeners.delete(fn)
  }
}
